import {
  Navigate,
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./context/ProtectedRoute";
import MainLogin from "./Pages/MainLogin";
import Login from "./Pages/Login";
import HomePage from "./Pages/HomePage";
import Inventory from "./Pages/Inventory";
import CashPOS from "./Pages/CashPOS";
import CashPOSPopUp from "./Pages/ORDERTAKER/CashPOS";
import CreditPOS from "./Pages/CreditPOS";
import Receipt from "./Pages/Receipt";
import TablesSeating from "./Pages/TablesSeating";
import PettyCash from "./Pages/PettyCash";
import ZandXReport from "./Pages/ZandXReport";
import ReceiptReports from "./Pages/ReceiptReplorts";
import SalesReport from "./Pages/SalesReport";
import SALESREPORTDETAILED from "./Pages/SALESREPORTDETAILED";
import UploadCategoryImage from "./Pages/UploadCategoryImage";
import CreditNoteCash from "./Pages/CreditNoteCash";
import CreditNoteInvoice from "./Pages/CreditNoteInvoice";
import TableOrders from "./Pages/TableOrders";
import POProcessing from "./Pages/POProcessing";
import ItemCreation from "./Pages/ItemCreation";
import LocationCreation from "./Pages/LocationCreation";
import SupplierCreation from "./Pages/SupplierCreation";
import AreaCreation from "./Pages/AreaCreation";
import Grn from "./Pages/Grn";
import CustomerMaster from "./Pages/CustomerMaster";
import ORDERTAKERDASHBOARD from "./Pages/ORDERTAKER/ORDERTAKERDASHBOARD";
import TakeOrder from "./Pages/ORDERTAKER/TakeOrder";
import MyListofOrders from "./Pages/ORDERTAKER/MyListofOrders";
import MySales from "./Pages/ORDERTAKER/MySales";
import ListOfOrders from "./Pages/ListOfOrders";
import BuffetOrder from "./Pages/BuffetOrder";
import RECIPEMASTER from "./Pages/RECIPEMASTER";
import DAYENDQUERIES from "./Pages/DAYENDQUERIES";
import DAYENDPROCEDURE from "./Pages/DAYENDPROCEDURE";

import BILLSPLITTING from "./Pages/ORDERTAKER/BILLSPLITTING";
import BILLMERGING from "./Pages/ORDERTAKER/BILLMERGING";
import PROCESSORDER from "./Pages/ORDERTAKER/PROCESSORDER";

import ItemAccompanimentMaster from "./Pages/ItemAccompanimentMaster";
import ItemAuxiliaryMaster from "./Pages/ItemAuxiliaryMaster";

// kitchen
import KitchenDashboard from "./Pages/Kitchen/KitchenDashboard";
import ListofOrdersNotStarted from "./Pages/Kitchen/ListofOrdersNotStarted";
import ListofOrdersKitchen from "./Pages/Kitchen/ListofOrdersKitchen";
import ListofOrdersReady from "./Pages/Dashboard/ListofOrdersReady";

// POS CASHIER
import PosCashierUnpaidBills from "./Pages/CASHIER/PosCashierUnpaidBills";
import SHIFTENDPROCEDURE from "./Pages/CASHIER/SHIFTENDPROCEDURE";
import SHIFTQUERIES from "./Pages/CASHIER/SHIFTQUERIES";
import POSRECEIPT from "./Pages/CASHIER/POSRECEIPT";
import CASHDROPS from "./Pages/CASHIER/CASHDROPS";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/" element={<MainLogin />} />
          <Route
            path="/HomePage"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ListOfOrders"
            element={
              <ProtectedRoute>
                <ListOfOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/BuffetOrder"
            element={
              <ProtectedRoute>
                <BuffetOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CashPOS"
            element={
              <ProtectedRoute>
                <CashPOSPopUp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PROCESSORDER"
            element={
              <ProtectedRoute>
                <PROCESSORDER />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CASHSALEPOS"
            element={
              <ProtectedRoute>
                <CashPOSPopUp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CreditPOS"
            element={
              <ProtectedRoute>
                <CreditPOS />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Receipt"
            element={
              <ProtectedRoute>
                <Receipt />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TABLESMASTER"
            element={
              <ProtectedRoute>
                <TablesSeating />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PettyCash"
            element={
              <ProtectedRoute>
                <PettyCash />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ZandXReport"
            element={
              <ProtectedRoute>
                <ZandXReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReceiptReports"
            element={
              <ProtectedRoute>
                <ReceiptReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/COLLECTIONREPORT"
            element={
              <ProtectedRoute>
                <ReceiptReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SalesReport"
            element={
              <ProtectedRoute>
                <SalesReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SALESREPORTDETAILED"
            element={
              <ProtectedRoute>
                <SALESREPORTDETAILED />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CreditNoteCash"
            element={
              <ProtectedRoute>
                <CreditNoteCash />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CreditNoteInvoice"
            element={
              <ProtectedRoute>
                <CreditNoteInvoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TableOrders"
            element={
              <ProtectedRoute>
                <TableOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/UploadCategoryImage"
            element={
              <ProtectedRoute>
                <UploadCategoryImage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/POPROCESSING"
            element={
              <ProtectedRoute>
                <POProcessing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ITEMSMASTER"
            element={
              <ProtectedRoute>
                <ItemCreation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AREAMASTER"
            element={
              <ProtectedRoute>
                <AreaCreation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ITEMACCOMPANIMENTMASTER"
            element={
              <ProtectedRoute>
                <ItemAccompanimentMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ITEMAUXILIARYMASTER"
            element={
              <ProtectedRoute>
                <ItemAuxiliaryMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/LOCATIONMASTER"
            element={
              <ProtectedRoute>
                <LocationCreation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SUPPLIERMASTER"
            element={
              <ProtectedRoute>
                <SupplierCreation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/GRNPROCESSING"
            element={
              <ProtectedRoute>
                <Grn />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CUSTOMERMASTER"
            element={
              <ProtectedRoute>
                <CustomerMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ORDERTAKERDASHBOARD"
            element={
              <ProtectedRoute>
                <ORDERTAKERDASHBOARD />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TakeOrder"
            element={
              <ProtectedRoute>
                <TakeOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MyListofOrders"
            element={
              <ProtectedRoute>
                <MyListofOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MySales"
            element={
              <ProtectedRoute>
                <MySales />
              </ProtectedRoute>
            }
          />

          {/* kitchen */}
          <Route
            path="/KitchenDashboard"
            element={
              <ProtectedRoute>
                <KitchenDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/POSDEPARTMENTSTATUSUPDATE"
            element={
              <ProtectedRoute>
                <KitchenDashboard />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/ListofOrdersNotStarted"
            element={
              <ProtectedRoute>
                <ListofOrdersNotStarted />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ListofOrdersKitchen"
            element={
              <ProtectedRoute>
                <ListofOrdersKitchen />
              </ProtectedRoute>
            }
          /> */}
          {/* Dashboard  */}
          <Route
            path="/ListofOrdersReady"
            element={
              <ProtectedRoute>
                <ListofOrdersReady />
              </ProtectedRoute>
            }
          />

          {/* POS CASHIER */}

            <Route
            path="/PosCashierUnpaidBills"
            element={
              <ProtectedRoute>
                <PosCashierUnpaidBills />
              </ProtectedRoute>
            }
          />

            <Route
            path="/UNPAIDBILLS"
            element={
              <ProtectedRoute>
                <PosCashierUnpaidBills />
              </ProtectedRoute>
            }
          />
            <Route
            path="/SHIFTENDPROCEDURE"
            element={
              <ProtectedRoute>
                <SHIFTENDPROCEDURE />
              </ProtectedRoute>
            }
          />
            <Route
            path="/SHIFTQUERIES"
            element={
              <ProtectedRoute>
                <SHIFTQUERIES />
              </ProtectedRoute>
            }
          />
            <Route
            path="/POSRECEIPT"
            element={
              <ProtectedRoute>
                <POSRECEIPT />
              </ProtectedRoute>
            }
          />
            <Route
            path="/CASHDROPS"
            element={
              <ProtectedRoute>
                <CASHDROPS />
              </ProtectedRoute>
            }
          />


          {/* POS ITEMS */}

                      <Route
            path="/RECIPEMASTER"
            element={
              <ProtectedRoute>
                <RECIPEMASTER />
              </ProtectedRoute>
            }
          />
                      <Route
            path="/DAYENDQUERIES"
            element={
              <ProtectedRoute>
                <DAYENDQUERIES />
              </ProtectedRoute>
            }
          />
                      <Route
            path="/DAYENDPROCEDURE"
            element={
              <ProtectedRoute>
                <DAYENDPROCEDURE />
              </ProtectedRoute>
            }
          />
                      <Route
            path="/BILLSPLITTING"
            element={
              <ProtectedRoute>
                <BILLSPLITTING />
              </ProtectedRoute>
            }
          />
                      <Route
            path="/BILLMERGING"
            element={
              <ProtectedRoute>
                <BILLMERGING />
              </ProtectedRoute>
            }
          />

          
        </Routes>
      </Router>
    </div>
  );
}

export default App;
